'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _require = require('./record'),
    PBRecord = _require.Record;

var utils = require('../utils');
/**
 * @typedef {{ key: Uint8Array, value: Uint8Array, timeReceived: string }} ProtobufRecord
 */


var Record = /*#__PURE__*/function () {
  /**
   * @param {Uint8Array} [key]
   * @param {Uint8Array} [value]
   * @param {Date} [timeReceived]
   */
  function Record(key, value, timeReceived) {
    _classCallCheck(this, Record);

    if (!(key instanceof Uint8Array)) {
      throw new Error('key must be a Uint8Array');
    }

    if (!(value instanceof Uint8Array)) {
      throw new Error('value must be a Uint8Array');
    }

    this.key = key;
    this.value = value;
    this.timeReceived = timeReceived;
  }

  _createClass(Record, [{
    key: "serialize",
    value: function serialize() {
      return PBRecord.encode(this.prepareSerialize()).finish();
    }
    /**
     * Return the object format ready to be given to the protobuf library.
     */

  }, {
    key: "prepareSerialize",
    value: function prepareSerialize() {
      return {
        key: this.key,
        value: this.value,
        timeReceived: this.timeReceived && utils.toRFC3339(this.timeReceived)
      };
    }
    /**
     * Decode a protobuf encoded record.
     *
     * @param {Uint8Array} raw
     */

  }], [{
    key: "deserialize",
    value: function deserialize(raw) {
      var message = PBRecord.decode(raw);
      return Record.fromDeserialized(PBRecord.toObject(message, {
        defaults: false,
        arrays: true,
        longs: Number,
        objects: false
      }));
    }
    /**
     * Create a record from the raw object returned from the protobuf library.
     *
     * @param {{ [k: string]: any }} obj
     */

  }, {
    key: "fromDeserialized",
    value: function fromDeserialized(obj) {
      var recvtime;

      if (obj.timeReceived) {
        recvtime = utils.parseRFC3339(obj.timeReceived);
      }

      var rec = new Record(obj.key, obj.value, recvtime);
      return rec;
    }
  }]);

  return Record;
}();

module.exports = Record;